import { createSlice } from "@reduxjs/toolkit";

type EligibilityToggleSliceState = {
  hideIneligible: boolean;
};

const initialState: EligibilityToggleSliceState = {
  hideIneligible: true,
};

const eligibilityToggleSlice = createSlice({
  name: "eligibilityToggle",
  initialState,
  reducers: {
    setHideIneligible(state, action) {
      state.hideIneligible = action.payload;
    },
    resetEligibilityToggle(state) {
      state.hideIneligible = true;
    },
  },
});

const { reducer } = eligibilityToggleSlice;

export const { setHideIneligible, resetEligibilityToggle } =
  eligibilityToggleSlice.actions;

export default reducer;
